import GenieMailboxSection from "@/components/agent/details/GenieMailboxSection";
import { OverviewSectionCard } from "@/components/agent/overview/OverviewSectionCard";
import { Agent } from "@/types/agent/agent";

interface GenieMailboxCardProps {
  agent: Agent;
  brand?: string;
}

export const GenieMailboxCard = ({ agent, brand = "#4E9CFF" }: GenieMailboxCardProps) => {
  const listenOnly = agent.type === "listener";
  const cardProps = {
    genieIcon: "mail" as const,
    brand,
    secondaryColor: agent.branding?.secondaryColor,
    gradientEnabled: agent.branding?.gradientEnabled,
    gradientAngle: agent.branding?.gradientAngle,
  };
  const section = (
    <GenieMailboxSection
      agentId={agent.id}
      agentName={agent.name}
      mailbox={agent.mailbox}
      brand={brand}
      listenOnly={listenOnly}
    />
  );

  return listenOnly ? (
    <OverviewSectionCard
      title="Email Listening"
      subtitle="Forward your support inbox here — your genie reads every email and flags what needs you"
      {...cardProps}
    >
      {section}
    </OverviewSectionCard>
  ) : (
    <OverviewSectionCard title="Genie Mailbox" subtitle="Forward your support inbox here and your genie answers it" {...cardProps}>
      {section}
    </OverviewSectionCard>
  );
};
